import { GenericServiceBase } from '@/services/generic-service';
import type { ResultadoDialogoMeta } from '@/utils/erroDialogoMeta';

export type FluxoDeDialogo =
    | 'WHATSAPP_EMBEDDED_SIGNUP' | 'WHATSAPP_OAUTH_ADMIN' | 'WHATSAPP_OAUTH_USUARIO' | 'WHATSAPP_COEXISTENCE'
    | 'INSTAGRAM_META' | 'INSTAGRAM_LOGIN' | 'MESSENGER_META';

export interface EncerramentoDeDialogo {
    resultado: ResultadoDialogoMeta;
    etapaMeta?: string;
    mensagem?: string;
}

/** Diálogo da Meta na área do cliente (`/meta-onboarding/dialogo`). */
export class MetaOnboardingDialogoService extends GenericServiceBase {
    constructor() { super('meta-onboarding/dialogo') }

    async abrir(corpo: { fluxo: FluxoDeDialogo; idInbox?: string }): Promise<{ idExecucao: string }> {
        return await this.f.post('/abrir', corpo) as { idExecucao: string };
    }

    async encerrar(idExecucao: string, corpo: EncerramentoDeDialogo): Promise<{ registrado: boolean; status: string | null }> {
        return await this.f.post(`/${idExecucao}/encerrar`, corpo) as { registrado: boolean; status: string | null };
    }
}

/** O mesmo no admin, mais o encerramento manual de execuções (`/admin/meta-trilha/onboarding`). */
export class MetaOnboardingDialogoAdminService extends GenericServiceBase {
    constructor() { super('admin/meta-trilha/onboarding') }

    async abrir(corpo: { fluxo: FluxoDeDialogo; idInbox?: string; idConta?: string }): Promise<{ idExecucao: string }> {
        return await this.f.post('/dialogo/abrir', corpo) as { idExecucao: string };
    }

    async encerrar(idExecucao: string, corpo: EncerramentoDeDialogo): Promise<{ registrado: boolean; status: string | null }> {
        return await this.f.post(`/dialogo/${idExecucao}/encerrar`, corpo) as { registrado: boolean; status: string | null };
    }

    async encerrarExecucao(
        idExecucao: string,
        corpo: { desfecho: 'FALHA' | 'RECUSADO' | 'ABANDONADA' | 'CONECTADO' | 'DESCONECTADO'; motivo?: string; resolverRoteamento?: boolean },
    ): Promise<{ idExecucao: string; status: string; desfecho: string; sessoesCanceladas: number; roteamentoResolvido: boolean }> {
        return await this.f.post(`/execucoes/${idExecucao}/encerrar`, corpo) as { idExecucao: string; status: string; desfecho: string; sessoesCanceladas: number; roteamentoResolvido: boolean };
    }
}
